
import team1 from '@/assets/img/vibef.avif'

import blog1 from '@/assets/img/bl-1.png'

import instra1 from '@/assets/img/i-1.png'
import instra2 from '@/assets/img/i-2.png'
import instra3 from '@/assets/img/i-3.png'
import instra4 from '@/assets/img/i-4.png'
import instra5 from '@/assets/img/i-5.png'
import instra6 from '@/assets/img/i-6.png'
import instra7 from '@/assets/img/i-7.png'
import instra8 from '@/assets/img/i-8.png'

import bg from '@/assets/img/cover-1.jpg'
import keramik from '@/assets/img/keramik_hero.png'
import interior from '@/assets/img/interior_hero.png'
import accessories from '@/assets/img/smykker_hero.png'
import strik from '@/assets/img/strik_hero.png'
import billedkunst from '@/assets/img/billedkunst_hero.png'

export const defaultHero = bg;


/*export const ProductData = [
    {
        id:1,
        image1:product1,
        image2:product1A,
        name:'Women Striped Shirt Dress',
        review:'5 Reviews',
        rate:['fas fa-star filled','fas fa-star filled','fas fa-star filled','fas fa-star filled','fas fa-star'],
        price:99,
        tag:'Sale',
        color:[''],
        size:[26,28,30,32],
        des:false,
        desRate:'0'
    },
]*/

export const Categories = [
    {
        id: 2,
        displayname: "INTERIØR",
        branche: "Interiør designere",
        name: "interior",
        hero: interior,
        subCategories: [
            { id: 45, name: "lamper",                 displayname: "Lamper", urlSlug: "lamper", metaTitle: "Lamper", metaDescription: "Køb Lamper på danmarks største markedsplads for kunstnere." },
            { id: 41, name: "møbler_træarbejde",      displayname: "Møbler & Træarbejde", urlSlug: "mobler_traearbejde", metaTitle: "Møbler & Træarbejde", metaDescription: "Køb Møbler & Træarbejde på danmarks største markedsplads for kunstnere." },
            { id: 27, name: "puder_taepper",         displayname: "Puder & Tæpper", urlSlug: "puder_taepper", metaTitle: "Puder & Tæpper", metaDescription: "Køb Puder & Tæpper på danmarks største markedsplads for kunstnere." },
            { id: 42, name: "vaegophæng",   displayname: "Vægophæng", urlSlug: "vaegophæng", metaTitle: "Vægophæng", metaDescription: "Køb Vægophæng på danmarks største markedsplads for kunstnere." },
            { id: 46, name: "andet_bolig",            displayname: "Andet", urlSlug: "andet_bolig", metaTitle: "Andet Interiør", metaDescription: "Køb Andet Interiør på danmarks største markedsplads for kunstnere." },
        ],
    },
    {
        id: 3,
        displayname: "KERAMIK",
        branche: "Keramikere",
        name: "keramik",
        hero: keramik,
        subCategories: [
            { id: 1, name: "kopper",                 displayname: "Kopper", urlSlug: "kopper", metaTitle: "Keramik Kopper", metaDescription: "Køb Keramik Kopper på danmarks største markedsplads for kunstnere." },
            { id: 2, name: "skåle_fade",             displayname: "Skåle & Fade", urlSlug: "skale_fade", metaTitle: "Keramik Skåle & Fade", metaDescription: "Køb Keramik Skåle & Fade på danmarks største markedsplads for kunstnere." },
            { id: 3, name: "tallerkener",            displayname: "Tallerkener", urlSlug: "tallerkener", metaTitle: "Keramik Tallerkener", metaDescription: "Køb Keramik Tallerkener på danmarks største markedsplads for kunstnere." },
            { id: 4, name: "vaser_krukker",          displayname: "Vaser & Krukker", urlSlug: "vaser_krukker", metaTitle: "Keramik Vaser & Krukker", metaDescription: "Køb Keramik Vaser & Krukker på danmarks største markedsplads for kunstnere." },
            { id: 5, name: "kander",                 displayname: "Kander", urlSlug: "kander", metaTitle: "Keramik Kander", metaDescription: "Køb Keramik Kander på danmarks største markedsplads for kunstnere." },
            { id: 6, name: "skulpturer_keramik",     displayname: "Skulpturer", urlSlug: "skulpturer_keramik", metaTitle: "Keramik Skulpturer", metaDescription: "Køb Keramik Skulpturer på danmarks største markedsplads for kunstnere." },
            { id: 7, name: "lysestager_keramik",     displayname: "Lysestager", urlSlug: "lysestager_keramik", metaTitle: "Keramik Lysestager", metaDescription: "Køb Keramik Lysestager på danmarks største markedsplads for kunstnere." },
            { id: 8, name: "andet_keramik",          displayname: "Andet", urlSlug: "andet_keramik", metaTitle: "Andet Keramik", metaDescription: "Køb Andet Keramik på danmarks største markedsplads for kunstnere." },
        ],
    },
    {
        id: 9,
        displayname: "SMYKKER & ACC",
        branche: "Smykke designere",
        name: "smykker",
        hero: accessories,
        subCategories: [
            { id: 17, name: "øreringe",   displayname: "Øreringe", urlSlug: "oereringe", metaTitle: "Øreringe", metaDescription: "Køb Øreringe på danmarks største markedsplads for kunstnere." },
            { id: 18, name: "halskæder",     displayname: "Halskæder", urlSlug: "halskaeder", metaTitle: "Halskæder", metaDescription: "Køb Halskæder på danmarks største markedsplads for kunstnere." },
            { id: 19, name: "armbånd",               displayname: "Armbånd", urlSlug: "armbaand", metaTitle: "Armbånd", metaDescription: "Køb Armbånd på danmarks største markedsplads for kunstnere." },
            { id: 20, name: "ringe",                 displayname: "Ringe", urlSlug: "ringe", metaTitle: "Ringe", metaDescription: "Køb Ringe på danmarks største markedsplads for kunstnere." },
            { id: 22, name: "tasker",    displayname: "Tasker", urlSlug: "tasker", metaTitle: "Tasker", metaDescription: "Køb Tasker på danmarks største markedsplads for kunstnere." },
            { id: 23, name: "andet_smykker",         displayname: "Andet", urlSlug: "andet_smykker", metaTitle: "Andre Smykker & Accessories", metaDescription: "Køb Andre Smykker & Accessories på danmarks største markedsplads for kunstnere." },
        ],
    },
    {
        id: 8,
        displayname: "STRIK & HÆKLE",
        branche: "Strik- og hæklere",
        name: "strik-haekle",
        hero: strik,
        subCategories: [
            { id: 24, name: "sweatre_trøjer",        displayname: "Sweatre & Trøjer", urlSlug: "sweatre_trojer", metaTitle: "Sweatre & Trøjer", metaDescription: "Køb Sweatre & Trøjer på danmarks største markedsplads for kunstnere." },
            { id: 25, name: "huer_vanter_sokker",    displayname: "Huer, Vanter & Sokker", urlSlug: "huer_vanter_sokker", metaTitle: "Huer, Vanter & Sokker", metaDescription: "Køb Huer, Vanter & Sokker på danmarks største markedsplads for kunstnere." },
            { id: 26, name: "tørklæder_sjaler",      displayname: "Tørklæder & Sjaler", urlSlug: "torklaeder_sjaler", metaTitle: "Tørklæder & Sjaler", metaDescription: "Køb Tørklæder & Sjaler på danmarks største markedsplads for kunstnere." },
            { id: 28, name: "bamser_figurer",        displayname: "Bamser & Figurer", urlSlug: "bamser_figurer", metaTitle: "Strikkede Bamser & Figurer", metaDescription: "Køb Strikkede Bamser & Figurer på danmarks største markedsplads for kunstnere." },
            { id: 29, name: "garn_kits",             displayname: "Garn & Kits", urlSlug: "garn_kits", metaTitle: "Garn & Kits", metaDescription: "Køb Garn & Kits på danmarks største markedsplads for kunstnere." },
            { id: 30, name: "andet_strik",           displayname: "Andet", urlSlug: "andet_strik", metaTitle: "Andet Strik & Hækle", metaDescription: "Køb Andet Strik & Hækle på danmarks største markedsplads for kunstnere." },
        ],
    },
    {
        id: 12,
        displayname: "BILLEDKUNST",
        branche: "Billedkunstnere",
        name: "billedkunst",
        hero: billedkunst,
        subCategories: [
            { id: 9,  name: "malerier",              displayname: "Malerier", urlSlug: "malerier", metaTitle: "Malerier", metaDescription: "Køb Malerier på danmarks største markedsplads for kunstnere." },
            { id: 10, name: "plakater",              displayname: "Plakater", urlSlug: "plakater", metaTitle: "Plakater", metaDescription: "Køb Plakater på danmarks største markedsplads for kunstnere." },
            { id: 11, name: "foto",                  displayname: "Foto", urlSlug: "foto", metaTitle: "Fotokunst", metaDescription: "Køb Fotokunst på danmarks største markedsplads for kunstnere." },
            { id: 12, name: "portrætter",            displayname: "Portrætter", urlSlug: "portraetter", metaTitle: "Portrætter", metaDescription: "Køb Portrætter på danmarks største markedsplads for kunstnere." },
            { id: 13, name: "grafik_tryk",           displayname: "Grafik & Tryk", urlSlug: "grafik_tryk", metaTitle: "Grafik & Tryk", metaDescription: "Køb Grafik & Tryk på danmarks største markedsplads for kunstnere." },
            { id: 14, name: "tegninger_skitser",     displayname: "Tegninger & Skitser", urlSlug: "tegninger_skitser", metaTitle: "Tegninger & Skitser", metaDescription: "Køb Tegninger & Skitser på danmarks største markedsplads for kunstnere." },
            { id: 15, name: "skulpturer_billedkunst",displayname: "Skulpturer", urlSlug: "skulpturer_billedkunst", metaTitle: "Skulpturer", metaDescription: "Køb Skulpturer på danmarks største markedsplads for kunstnere." },
            { id: 16, name: "andet_billedkunst",     displayname: "Andet", urlSlug: "andet_billedkunst", metaTitle: "Andet Billedkunst", metaDescription: "Køb Andet Billedkunst på danmarks største markedsplads for kunstnere." },
        ],
    },
];

import { computed } from 'vue'
import { useProductStore } from '@/stores/useProductStore';

export const ProductData = computed(() => {
    // It's important to initialize the store *before* accessing it.
    // We did this in main.js
    const store = useProductStore();
    return store.productData;
});


export const clientData = [
    {
        image:team1,
        name:'Vibe Falkenberg',
        position:'Indehaver af Keramoda.dk',
        desc:'Jeg har omsat for over 500.000 kr. på min webshop, det første år - uden nogen teknisk erfaring.'
    },
]

export const blogData = [
    {
        id:1,
        image:blog1,
        date:'13th March 2025',
        title:`Let's start bring sale on this saummer vacation.`,
        desc:`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis`
    },
]

export const instraImg = [
    instra1,instra2,instra3,instra4,instra5,instra6,instra7,instra8,instra2,instra3,instra4,
]


export const footerTopData = [
    {
        icon:'fas fa-shopping-basket',
        title:'Støt kunstnere og designere',
        desc:'Alle indtægter går ubeskåret til kunstnerne selv'
    },
    {
        icon:'far fa-credit-card',
        title:'Sikker betaling',
        desc:'På alle webshops hos YOKO'
    },
    {
        icon:'fas fa-trophy',
        title:'Kurateret udvalg',
        desc:'Nøje udvalgte kunstnere og designere'
    },
]


export const footerLink1 = [
    'Contact Us','About Page','Size Guide','Shipping & Returns',`FAQ's Page`,'Privacy'
]

export const footerLink2 = [
    `Men's Shopping`,`Women's Shopping`,`Kids's Shopping`,`Furniture`,`Discounts`
]

export const footerLink3 = [ 
    'About','Blog','Affiliate','Login'
]

export const blogCategory = [
    {
        name:'Lifestyle',
        value:'09'
    },
    {
        name:'Travel',
        value:'12'
    },
    {
        name:'Fashion',
        value:'19'
    },
    {
        name:'Branding',
        value:'17'
    },
    {
        name:'Music',
        value:'10'
    },
]

export const trandingPost = [
    {
        image:blog1,
        title:'Alonso Kelina Falao Asiano Pero',
        time:'10 Min ago'
    }
]

export const blogTag = [
    'Lifestyle','Travel','Fashion','Branding','Music'
]
